const routes = [{
  path: '/authority',
  component: () => import('@/views/authority'),
  name: 'authority',
  meta: {
    title: '权限分配'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/authority.js